import { type DataLayerData, type DataLayerMeta } from '../types/types.js'

export const getDefaultMetaAttributes = (
  data: DataLayerData | Record<string, unknown>
): {
  is_native: string
  native_version: string
  release_version: string
  country: string
  language: string
} => {
  const {
    app: { isNative, locale, nativeVersion, releaseVersion, tld },
  } = data as DataLayerMeta

  return {
    is_native: isNative.toString(),
    native_version: nativeVersion,
    release_version: releaseVersion,
    country: tld,
    language: locale,
  }
}
